export const buildBankCopyText = (bankName: string, locationName: string, routingNumbers: string[]): string =>
  [bankName, locationName, routingNumbers.join(', ')].filter(Boolean).join('\n');

export function isValidRoutingNumber(value: string | undefined) {
  if (!value || value.length !== 9) {
    return false;
  }
  const digits = value.split('').map((d) => parseInt(d, 10));
  const checkSum =
    digits[0] * 3 +
    digits[1] * 7 +
    digits[2] * 1 +
    digits[3] * 3 +
    digits[4] * 7 +
    digits[5] * 1 +
    digits[6] * 3 +
    digits[7] * 7 +
    digits[8] * 1;

  return checkSum % 10 === 0;
};
